import React from "react";
import { Modal, Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiMonitor, mdiCellphone } from "@mdi/js";
import "./continueWithComputerModal.css";

const ContinueWithComputerModal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="continue-computer-modal"
    >
      <Modal.Body className="py-0">
        <Modal.Header className="modal-title-with-border" closeButton>
          <Modal.Title>Continue with computer</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-1 px-2">
          <div className="mb-4">
            <div className="d-flex align-items-start">
              <Icon
                path={mdiMonitor}
                size={1}
                className="text-primary me-3 mt-1 flex-shrink-0"
              />
              <div>
                <p className="mb-0">
                  Please open the shared link on your computer to import your
                  templates.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-0">
            <div className="d-flex align-items-start">
              <Icon
                path={mdiCellphone}
                size={1}
                className="text-primary me-3 mt-1 flex-shrink-0"
              />
              <div>
                <p className="mb-0">
                  Once you're done. You can use them in the Mobile App
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={onHide}>
            Got it
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default ContinueWithComputerModal;
